import axios from "axios";

const getEnvironment = () => {
  const url = window.location.href;
  if (url.includes("localhost")) {
    return { ENV_NODE: "LOCAL", ENV_PYTHON: "LOCAL" };
  } else {
    return { ENV_NODE: "PROD", ENV_PYTHON: "PROD" };
  }
};

const { ENV_NODE, ENV_PYTHON } = getEnvironment();

const BASE_URL_NODE = {
  LOCAL: process.env.REACT_APP_NODE_URL_LOCAL,
  PROD: process.env.REACT_APP_NODE_URL_PROD,
};

const BASE_URL_PYTHON = {
  LOCAL: process.env.REACT_APP_PYTHON_URL_LOCAL,
  PROD: process.env.REACT_APP_PYTHON_URL_PROD,
};

export const axiosInstance = axios.create({
  baseURL: BASE_URL_NODE[ENV_NODE],
  withCredentials: true,
});

export const axiosInstancePython = axios.create({
  baseURL: BASE_URL_PYTHON[ENV_PYTHON],
  withCredentials: true,
});

const addTokenInterceptor = (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

axiosInstance.interceptors.request.use(addTokenInterceptor);
axiosInstancePython.interceptors.request.use(addTokenInterceptor);

export const getPythonBaseUrl = () => BASE_URL_PYTHON[ENV_PYTHON];
